import { useMemo } from "react";

import Timestamp from "components/Timestamp";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentResourceOperation } from "types/generated";
import { makeTimestampToCopy } from "ds/components/Table/helpers";

import useCellCopyAction from "../useCellCopyAction";

const IntentProjectOperationsTableCreatedAtCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<IntentResourceOperation>) => {
  const timestamp = item.createdAt;
  const copyAction = useCellCopyAction({
    text: makeTimestampToCopy(timestamp),
  });

  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <Timestamp timestamp={timestamp} />
    </TableSimpleCell>
  );
};

export default IntentProjectOperationsTableCreatedAtCell;
